import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteProductMutation} from 'api';
import {useSnackbar} from 'notistack';

function ProductDeleteIconButton({productId}) {
  const [deleteProduct, deleteProductResult] = useDeleteProductMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteProduct(productId).unwrap();
      enqueueSnackbar('Product deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error?.data?.status || undefined;
      enqueueSnackbar(message || `Error deleting Product`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Product</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Product?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteProductResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteProductResult.isLoading}
            color="error"
            endIcon={deleteProductResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteProductResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default ProductDeleteIconButton;
